export enum EngagementAssociatedType {
  User = 'USER',
  Organisation = 'ORGANISATION',
}

export enum EngagementType {
  AddMonitoringDomain = 'MONITORING_ADD_DOMAIN',
  MonitoringBenefits = 'MONITORING_BENEFITS',
  MonitoringDiscoveryInterest = 'MONITORING_DISCOVERY_INTEREST',
  PLGHubSpotForm = 'PLG_HUBSPOT_FORM',
  PLGPostAssessmentModal = 'PLG_POST_ASSESSMENT_MODAL',
  SupplierAssessmentPdfExported = 'SUPPLIER_ASSESSMENT_PDF_EXPORTED',
  SupplierAssessmentCsvExported = 'SUPPLIER_ASSESSMENT_CSV_EXPORTED',
  SupplierAssessmentApproved = 'SUPPLIER_ASSESSMENT_APPROVED',
  SupplierAssessmentRejected = 'SUPPLIER_ASSESSMENT_REJECTED',
  SupplierConnectionRequested = 'SUPPLIER_CONNECTION_REQUESTED',
  AutoSuggestModal = 'AUTO_SUGGEST_MODAL',
  AutoSuggestBanner = 'AUTO_SUGGEST_BANNER',
  StartCompletingProfileBanner = 'START_COMPLETING_PROFILE_BANNER',
  ClientMonitoringInterestDismissed = 'CLIENT_MONITORING_INTEREST',
  WelcomeModal = 'WELCOME_MODAL',
  GettingStartedAddColleague = 'GETTING_STARTED_ADD_COLLEAGUE',
}

export type Engagement = {
  id: string;
  associatedType: EngagementAssociatedType;
  associatedID: string;
  engagementType: EngagementType;
  engagementCount: number;
  lastSessionID: string;
};
